import React from "react";
import Reactportal from "../../Reactportal/Reactportal";

const TableOptions = (props) => {
  const { show, hanleTableOptions, handleChangeTableOptions, title, isgrouping } = props;
  return (
    <Reactportal open={show} TypeOfPortal={"Table options"} onClose={() => hanleTableOptions()}>
      <div className="table_option_parent">
        <div className="dragableDiv">
          <input type="checkbox" checked={isgrouping} onChange={(e) => handleChangeTableOptions(e, "GROUP_BY")} />
          Table GroupBy ({`${title} Table`})
        </div>
      </div>
    </Reactportal>
  );
};

export default TableOptions;
